<template>
  <div class="textarea">
    <div class="textarea__label">Marka'ya ileteceğiniz gizli mesaj:</div>
    <div class="textarea__label -message">Bu formu dolduran kişi bu mesajı asla görmez</div>
    <textarea
      class="textarea__input"
      :style="`max-height: ${maxheight}px; min-height: ${minheight}px`"
      @keyup="changed"
      v-model="val"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    maxheight: {
      type: Number,
      default: null
    },
    minheight: {
      type: Number,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  watch: {
    value: function(val) {
      this.val = val;
    }
  },
  methods: {
    changed: function(e) {
      e.target.style.height = 0;
      e.target.style.height = `${e.srcElement.scrollHeight + 20}px`;

      this.$emit("input", e.target.value);

      return;
    }
  }
};
</script>